import React from 'react';

interface GoalMarkerProps {
  position?: string;
  isLast?: boolean;
  labelName?: string;
  tierThreshold?: string;
  tierIcon?:string;
}

const GoalMarker: React.FC<GoalMarkerProps> = ({ position,  isLast, labelName, tierThreshold, tierIcon }) => {
  const translateClass = isLast ? '-translate-x-full' : '-translate-x-1/2';
  const classes = position
    ? `absolute ${translateClass} -top-1.5 rounded-full flex items-center justify-center w-5 h-5 border-4 border-grey-5`
    : 'rounded-full flex items-center justify-center w-6 h-6';
  const labelClasses = position
    ? `absolute ${translateClass} top-4 flex items-center justify-center body-xxs`
    : 'flex items-center justify-center';
  const thresholdClasses = position
    ? `absolute ${translateClass} -top-6 flex items-center justify-center body-xxs`
    : 'flex items-center justify-center';

  return (
    <>
      <div
        className={thresholdClasses}
        style={{
          ...(position && { left: position }),
        }}>
        {tierThreshold}
      </div>
      <div
        className={classes}
        style={{
          ...(position && { left: position }),
          background: `#2BCE38`
        }}
      >
      </div>
      <div
        className={labelClasses}
        style={{
          ...(position && { left: position })
        }}>
        <div className="flex flex-col items-center">
          <div className="text-2xl">{tierIcon}</div>
          <div className="body-xxxs font-semibold whitespace-nowrap">{labelName}</div>
        </div>
      </div>
    </>

  );
};

export default GoalMarker;